"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var input_base_1 = __importDefault(require("@prezzee/input-base"));
var FilledInput_style_1 = __importDefault(require("./FilledInput.style"));
var form_control_1 = require("@prezzee/form-control");
var FilledInput = (0, react_1.forwardRef)(function (_a, ref) {
    var disableUnderline = _a.disableUnderline, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, hiddenLabel = _a.hiddenLabel, _c = _a.multiline, multiline = _c === void 0 ? false : _c, _d = _a.type, type = _d === void 0 ? 'text' : _d, rest = __rest(_a, ["disableUnderline", "fullWidth", "hiddenLabel", "multiline", "type"]);
    var formControl = (0, form_control_1.useFormControl)();
    return ((0, jsx_runtime_1.jsx)(input_base_1.default, __assign({ fullWidth: fullWidth, multiline: multiline, styles: {
            root: (0, FilledInput_style_1.default)(formControl.focused, !!formControl.error, !!(rest === null || rest === void 0 ? void 0 : rest.startAdornment), !!(rest === null || rest === void 0 ? void 0 : rest.endAdornment)),
        }, ref: ref, type: type }, rest)));
});
FilledInput.displayName = 'PrezzeeFilledInput';
exports.default = FilledInput;
//# sourceMappingURL=FilledInput.js.map